var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooTwit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2887 28C9.05374 28 6.03817 27.0591 3.5 25.4356C5.65499 25.5751 9.45807 25.2411 11.8236 22.9848C8.26508 22.8215 6.66026 20.0923 6.45094 18.926C6.75329 19.0426 8.1953 19.1826 9.00934 18.856C4.9159 17.8296 4.28793 14.2373 4.42748 13.141C5.195 13.6775 6.49745 13.8641 7.00913 13.8174C3.19479 11.0882 4.56703 6.98276 5.24151 6.09635C7.97882 9.88867 12.0812 12.0186 17.1564 12.137C17.0607 11.7174 17.0102 11.2804 17.0102 10.8316C17.0102 7.61092 19.6134 5 22.8247 5C24.5025 5 26.0144 5.71275 27.0757 6.85284C28.1969 6.59011 29.8843 5.97507 30.7092 5.4432C30.2934 6.93611 28.9989 8.18149 28.2159 8.64308C28.2095 8.62731 28.2224 8.65878 28.2159 8.64308C28.9037 8.53904 30.7648 8.18137 31.5 7.68256C31.1364 8.52125 29.764 9.91573 28.6377 10.6964C28.8473 19.9381 21.7765 28 12.2887 28Z",
    fill: "#47ACDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooTwit);
export default __webpack_public_path__ + "static/media/fooTwit.549b2747fdd5c53bb7928fcabeff4f0d.svg";
export { ForwardRef as ReactComponent };